import Tooltip from './tooltip.element.js';

export default Tooltip;

Tooltip.define('wje-tooltip', Tooltip);
